import { CSSProperties } from 'react';
import './Loading.css';

interface ILoading {
  style?: CSSProperties;
  loadingContainerClass?: string;
}

export default function Loading({style, loadingContainerClass}: ILoading) {
  return (
    <div style={style} className={`spinner-container ${loadingContainerClass ? loadingContainerClass : ''}`}>
      <div className='spinner'></div>
      <div>Loading...</div>
    </div>
  )
}
